var map = {
	"./arb.svg": 55491,
	"./arrow-up.svg": 92601,
	"./arrow.svg": 27933,
	"./base.svg": 58893,
	"./bid.svg": 67447,
	"./camelot.svg": 78089,
	"./caret-up.svg": 27111,
	"./cbETH.svg": 40906,
	"./claim.svg": 78410,
	"./connectors/arrow-right.svg": 92181,
	"./connectors/coinbaseWalletIcon.svg": 31125,
	"./connectors/gnosisWalletIcon.svg": 86748,
	"./connectors/metamask-fox.svg": 53530,
	"./connectors/walletConnectIcon.svg": 51475,
	"./cookie.svg": 88144,
	"./dark-arrow.svg": 42734,
	"./discord.svg": 32338,
	"./eth.svg": 16011,
	"./ethereum.svg": 47741,
	"./galxe.svg": 7115,
	"./gm-eth.svg": 7968,
	"./grt.svg": 94067,
	"./leaderboard-leaders-badge.svg": 36252,
	"./leaderboard-pillars.svg": 69335,
	"./magic.svg": 60627,
	"./mine.svg": 34019,
	"./od-full-logo-dark.svg": 98378,
	"./od-full-logo-grey.svg": 78087,
	"./od-full-logo-light.svg": 53202,
	"./od-logo-grey.svg": 95135,
	"./od-logo.svg": 75377,
	"./od-token.svg": 13987,
	"./odg-token.svg": 41166,
	"./op-img.svg": 74725,
	"./optimism.svg": 74476,
	"./parachute-icon.svg": 78415,
	"./pendle-pt-reth.svg": 73545,
	"./pendle-pt-wsteth.svg": 36601,
	"./polygon.svg": 26180,
	"./pufeth.svg": 79620,
	"./rETH.svg": 57161,
	"./sell-od.svg": 52306,
	"./stETH.svg": 21420,
	"./tx-failed-icon.svg": 66362,
	"./tx-submitted-icon.svg": 76228,
	"./tx-waiting-for-confirmation-icon.svg": 77122,
	"./uniswap-icon.svg": 75133,
	"./unknown-token.svg": 76748,
	"./wallet-icon.svg": 59261,
	"./wsteth.svg": 54265,
	"./zealy.svg": 44803
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91980;